export default __webpack_public_path__ + "static/media/tarra-h2h-picturemark-d.4d145cef.svg";